import { message } from "antd";

import { showAPIErrorMessage } from "utilities/apiHandler";

import { btDeleteConfirmAsync } from "commonComponents/btWrappers/BTConfirm/BTConfirm";

export async function DeleteSelectionOption(
    selectionOptionId: number,
    jobId: number,
    deleteOption: (params: {
        selectionOptionId: number;
        params: { jobParam: number };
    }) => Promise<void>,
    goBack?: () => void,
) {
    try {
        const userChoice = await btDeleteConfirmAsync({
            cancelText: "Cancel",
            content: "The client will no longer see this selection option",
            okText: "Delete",
            okType: "danger",
            title: "Delete selection option",
        });

        if (userChoice === "cancel") {
            return false;
        }

        await deleteOption({
            selectionOptionId: selectionOptionId,
            params: { jobParam: jobId },
        });

        void message.success("Selection option deleted");
        if (goBack) {
            goBack();
        }
        return true;
    } catch (e) {
        showAPIErrorMessage(e, "Selection option could not be deleted");
        return false;
    }
}
